import { useTranslations } from 'next-intl';
import { Modal } from '@/component/Modal';

const sortByName = function (a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
};

export function AmenitiesModal({ amenities, show, close }) {
  const t = useTranslations();

  const header = (
    <div
      className="text-base md:text-2xl font-semibold flex gap-1 items-center max-md:order-2"
      data-testid="amenities-modal-header"
    >
      <span className="text-slate-700">{t('apartment.amenities.title')}</span>
    </div>
  );

  return (
    <Modal header={header} show={show} close={close}>
      <ul className="grid sm:grid-cols-2 gap-y-6 gap-x-[46px]">
        {[...amenities].sort(sortByName).map((amenity, i) => (
          <li key={i} className="col-span-1 gap-y-3 inline-flex items-center">
            {amenity.iconName && (
              <i
                className={`inline-flex justify-center items-center text-primary-800 self-start text-[24px] icon-mr icon-${amenity.iconName}`}
              />
            )}
            <span className="text-slate-500 text-base">{amenity.name}</span>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
